/**
 * What a surface shows while an installed module's code has not arrived.
 *
 * ONE COMPONENT, because the message was copied twice and would have been
 * copied a third time. Rendering nothing here is the failure this exists to
 * prevent: an empty surface cannot tell a person "not yet" from "never", nor
 * either from chrome they emptied on purpose.
 *
 * The RECOVERY line is the one thing that differs per surface, so it is a
 * prop: a slot goes back to the built-in through Settings, a thread renderer
 * is removed there, an editor falls back the moment the package is removed.
 * Saying which is the difference between a message and a dead end.
 */

export function ContributionWaiting({
  name,
  what,
  recovery,
}: {
  /** The package's name, so the person knows whose code is missing. */
  name: string
  /** What kind of thing it is, in the sentence: "the fill's", "the renderer's". */
  what: string
  /** How to get the built-in back, in one sentence. */
  recovery: string
}) {
  return (
    <div className="flex h-full flex-col justify-center gap-1 bg-background p-3 text-[11px] text-muted-foreground">
      <span className="font-medium text-foreground">{name}</span>
      <span className="leading-snug">
        Waiting for its code to arrive. If this does not clear, {what} view
        document has not synced to this device.
      </span>
      <span className="leading-snug">{recovery}</span>
    </div>
  )
}
